export const OrionHowItWorks: React.FC = () => {
  return (
    <div>
      <ul>
        <li>Sync your contacts between Orion and Zocks</li>
        <li>Create new or update your Orion contacts from meeting insights, emails or documents</li>
        <li>Prepare for meetings using combined data from Zocks, Orion, and your connected systems.</li>
        <li>Get instant insights from Orion with the Ask Anything AI Assistant</li>
        <li>Generate email replies based on Orion portfolio information</li>
        <li>Fill Zocks Forms utilizing portfolio management data from Orion</li>
      </ul>
    </div>
  )
}
